export const navMap = {
    workers: {
        name: 'Workers',
        path: '/admin/workers',
    },
    clients: {
        name: 'Clients',
        path: '/admin/clients',
    },
    services: {
        name: 'Services',
        path: '/admin/services',
    },
    settings: {
        name: 'Settings',
        path: '/admin/settings',
    },
    admins: {
        name: 'Admins',
        path: '/admin/admins',
    },
    orders: {
        name: 'Orders',
        path: '/admin/orders',
    },
    calendar: {
        name: 'Kalender',
        path: '/admin/calendar',
    },
}